// extracted by mini-css-extract-plugin
export const author__photo = "Author-module--author__photo--3fdRL";
export const author__title = "Author-module--author__title--3d4Xc";
export const author__titleLink = "Author-module--author__title-link--29hpF";
export const author__subtitle = "Author-module--author__subtitle--1qG7V";